// src/About.js
import React from 'react';

function Contact() {
  return (
    <div>
      <h2>Contact Us</h2>

    </div>
  );
}

export default Contact;
